<template>
    <div class="menu-item">
        <router-link
            v-if="routerLink"
            :to="generatedRoute"
            class="parent-link"
            @click.native="changeUrlEndingAndEmitClicked"
        >
            <i @click="hideSideMenuIfMobile" :class="iconsClass">{{this.icon}}</i>
            <span @click="hideSideMenuIfMobile">{{this.text}}</span>
        </router-link>
        <a v-else class="parent-link" @click="toggleCollapse">
            <i :class="iconsClass">{{this.icon}}</i>
            <span>{{this.text}}</span>
            <i
                v-show="subItems.length > 0"
                class="material-icons-outlined arrow"
            >{{isCollapsed ? "keyboard_arrow_down" : "keyboard_arrow_right"}}</i>
        </a>
        <ul v-if="subItems.length > 0" :class="{collapsed: isCollapsed}">
            <li v-for="(item, index) in subItems" :key="index">
                <i class="material-icons">fiber_manual_record</i>
                <router-link :to="item.routerLink">
                    <span @click="hideSideMenuIfMobile">{{item.title}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        icon: String,
        routerLink: String,
        outlined: {
            type: Boolean,
            default: true,
        },
        subItems: {
            type: Array,
            default: () => [],
        },
        hideSideMenuIfMobile: Function,
    },
    computed: {
        iconsClass() {
            return this.outlined ? 'material-icons-outlined' : 'material-icons'
        },
        generatedRoute() {
            return `${this.routerLink}/rm${this.rand}`
        },
    },
    data: function() {
        return {
            isCollapsed: true,
            //rand is added to the url as an optional parameter, 
            //because we need the main component to update every time url changes.
            //router-view has url fullpath as its :key for this reason.
            rand: Math.floor(Math.random() * 10000), 
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed
        },
        changeUrlEndingAndEmitClicked() {
            this.rand = Math.floor(Math.random() * 10000)
            this.$emit('clicked')
        },
    },
}
</script>

<style lang="scss" scoped>
.menu-item {
    height: 68 * $rem;
    display: flex;
    align-items: center;
    padding-left: 46 * $rem;
    border-bottom: $rem solid #eff0f3;

    a {
        text-decoration: none;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;

        i {
            color: #d0d2db;
            font-size: 24 * $rem;
            margin-right: 14 * $rem;
        }

        span {
            color: #292929;
            font-weight: 700;
            font-size: 14 * $rem;
        }
    }
}
</style>

